<field-text {(field)}="code" format="pint" required="true" required-default-value="1000"></field-text>
<field-switch {(field)}="outputActivated"></field-switch>
